module.exports = __webpack_public_path__ + "img/bose-logo.e96c42a7.svg";